import React from 'react';
import { connect } from 'react-redux';
import { MediaImagesList } from '../menus/MediaImagesList';
import platformDetection from '../../components/utils/PlatformDetection';
import storeManager from '../../store/StoreManager';
import modeConstants from '../../constants/ModeConstants';
import { changeCartoonistTabIndex, changeContextMode, selectMyMediaCategory } from '../../actions/MenuActions';
import locales from '../../locales/LocalesManager';
import properties from '../../constants/Properties';
import { OnOffToggleButton } from './OnOffToggleButton';
import appParameters from '../../components/utils/AppParameters';
import mouseUtils from '../../components/utils/MouseUtils';


const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeConstants.CONTEXT_NONE));
    },
    shouldComponentUpdate(newProps) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 6
        };

        var caption = locales.getCaption('mainMenuMedia', 'hover');

        var closeButtonStyle = {
            position: 'absolute',
            width: 24,
            height: 24,
            top: 3,
            right: 28,
            cursor: 'pointer',
            borderStyle: 'none',
            background: 'none',
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 4,
            right: 4,
            cursor: 'pointer'
        };

        var ariaLabel = locales.getCaption('exit', 'other') + ' ' + caption;

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{caption}</span>
                <button id="firstFocusableObject" aria-label={ariaLabel} style={closeButtonStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        switch (this.props.index) {
            case 0: {
                this.props.dispatch(selectMyMediaCategory(modeConstants.IMAGES));
                this.props.dispatch(changeCartoonistTabIndex(7));
                break;
            }

            case 1: {
                this.props.dispatch(selectMyMediaCategory(modeConstants.VIDEOS));
                this.props.dispatch(changeCartoonistTabIndex(8));
                break;
            }
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.category != newProps.category)
            return true;
        else
            return false;
    },
    render() {
        var iconColor;
        var buttonColor;
        var videoSelected = false;

        if (this.props.category && this.props.category == modeConstants.VIDEOS)
            videoSelected = true;

        if (this.props.index == 0) { // IMAGES button
            if (videoSelected == false) {
                iconColor = 'white';
                buttonColor = properties.BROWSER_SELECTED_COLOR;
            } else {
                if (this.state.isOver == true) {
                    iconColor = properties.CONTEXT_HOVER_COLOR;
                    buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
                } else {
                    iconColor = 'black';
                    buttonColor = '#D7D7D7';
                }
            }

        } else { // VIDEO button
            if (videoSelected == true) {
                iconColor = 'white';
                buttonColor = properties.BROWSER_SELECTED_COLOR;
            } else {
                if (this.state.isOver == true) {
                    iconColor = properties.CONTEXT_HOVER_COLOR;
                    buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
                } else {
                    iconColor = 'black';
                    buttonColor = '#D7D7D7';
                }
            }
        }

        var topPosition = 0;
        var left = this.props.index == 0 ? 0 : properties.BROWSER_WIDTH / 2;

        var buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: properties.BROWSER_WIDTH / 2,
            height: properties.BROWSER_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            left: left,
            top: topPosition,
            color: 'white',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#FFFFFF',
            cursor: 'pointer'
        };

        var spanStyle = {
            color: iconColor,
            fontSize: 16,
            position: 'absolute',
            width: buttonStyle.width - 2 * 5,
            left: 5,
            top: 5,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'center',
            cursor: 'pointer'
        };

        var text = this.props.text;

        if (this.props.index == 0) {
            text = locales.getCaption('ImagesButton', 'myFiles');
        } else {
            text = locales.getCaption('VideosButton', 'myFiles');
        }

        return (
            <button style={buttonStyle} aria-label={text} onClick={this.onClick} onTouchStart={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <span style={spanStyle}>{text}</span>
            </button>
        );
    }
});

export const LeftMediaMenuContent = React.createClass({
    componentDidMount() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('firstFocusableObject');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    shouldComponentUpdate(newProps) {
        if (this.props.myMediaCategory != newProps.myMediaCategory || this.props.useImageAsBackground != newProps.useImageAsBackground || this.props.useVideoAsBackground != newProps.useVideoAsBackground || this.props.accordionWidth != newProps.accordionWidth || this.props.windowHeight != newProps.windowHeight || this.props.mediaFilesDataProvider != newProps.mediaFilesDataProvider)
            return true;
        else
            return false;
    },
    render() {
        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        const listHeight = this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT;
        var mediaMenuStyle = {
            position: 'absolute',
            top: properties.CLIPART_BUTTON_HEIGHT,
            width: this.props.accordionWidth,
            height: listHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        var dataProvider = [];
        var isVideo = false;

        if (this.props.myMediaCategory == modeConstants.IMAGES) {
            if (this.props.mediaFilesDataProvider)
                dataProvider = this.props.mediaFilesDataProvider.imagesDataProvider;
        } else {
            if (this.props.mediaFilesDataProvider)
                dataProvider = this.props.mediaFilesDataProvider.videosDataProvider;

            isVideo = true;
        }

        if (!platformDetection.isIOSApp())
            dataProvider = [{isUploadButton: true}].concat(dataProvider);

        var onOffButtonProperties = {};
        var onOffButton;
        var gap = 5;

        onOffButtonProperties.topPosition = properties.BROWSER_BUTTON_HEIGHT + gap;
        onOffButtonProperties.leftPosition = properties.MY_MEDIA_FILES_GAP;
        onOffButtonProperties.trackWidth = properties.TOGGLE_TRACK_WIDTH;
        onOffButtonProperties.trackHeight = properties.TOGGLE_TRACK_HEIGHT;
        onOffButtonProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
        onOffButtonProperties.thumbSize = properties.TOGGLE_THUMB_SIZE;
        onOffButtonProperties.dispatch = this.props.dispatch;
        onOffButtonProperties.width = properties.BROWSER_WIDTH - 2 * properties.MY_MEDIA_FILES_GAP;

        onOffButtonProperties.isMediaFilesElement = true;

        if (isVideo) {
            onOffButtonProperties.useVideoAsBackground = this.props.useVideoAsBackground;
            onOffButtonProperties.isVideo = true;
            onOffButton = <OnOffToggleButton properties={onOffButtonProperties} dispatch={this.props.dispatch} shapeModel={this.props.contextTarget}/>
        }
        else {
            onOffButtonProperties.useImageAsBackground = this.props.useImageAsBackground;
            onOffButtonProperties.isVideo = false;
            onOffButton = <OnOffToggleButton properties={onOffButtonProperties} dispatch={this.props.dispatch} shapeModel={this.props.contextTarget}/>;
        }

        var buttonsHolder =
            <div>
                <Button index={0} category={this.props.myMediaCategory} dispatch={this.props.dispatch}/>
                <Button index={1} category={this.props.myMediaCategory} dispatch={this.props.dispatch}/>
            </div>;

        return (
            <div style={menuStyle} id="leftMediaMenu">
                <Title accordionWidth={this.props.accordionWidth}/>
                <div style={mediaMenuStyle}>
                    {buttonsHolder}
                    <div>
                        {onOffButton}
                    </div>
                    <MediaImagesList isVideo={isVideo} accordionWidth={this.props.accordionWidth} dataProvider={dataProvider} height={listHeight} gap={gap}/>
                </div>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var myMediaCategory = state.menu.myMediaCategory;
    var useImageAsBackground = state.menu.useImageAsBackground;
    var useVideoAsBackground = state.menu.useVideoAsBackground;
    var accordionWidth = state.accordion.width;
    const mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;

    if (myMediaCategory == undefined)
        myMediaCategory = modeConstants.IMAGES;

    if (useImageAsBackground == undefined)
        useImageAsBackground = false;

    if (useVideoAsBackground == undefined)
        useVideoAsBackground = true;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    return {
        myMediaCategory,
        useImageAsBackground,
        useVideoAsBackground,
        accordionWidth,
        mediaFilesDataProvider,
    };
}

export const LeftMediaMenu = connect(mapStateToProps)(LeftMediaMenuContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/LeftMediaMenu.js
 **/